import { Extension } from '@tiptap/core';

// Custom Extension to handle '/' key
const KeyboardShortcuts = Extension.create({
  name: 'keyboardShortcuts',

  // Accept options during initialization
  addOptions() {
    return {
      handleBoldShortcut: null,
      handleItalicsShortcut: null,
      handleAttributesShortcut: null,
      handleEmojiShortcut: null,
      handleAddLink: null,
      handleAddMedia: null,
    };
  },
  addKeyboardShortcuts() {
    return {
      // CMD + B (on Mac)
      'Mod-b': ({ editor }) => {
        if (this.options.handleBoldShortcut) {
          this.options.handleBoldShortcut(editor);
        }
        return true; // returning true prevents the default behavior
      },

      // CMD + I (on Mac)
      'Mod-i': ({ editor }) => {
        if (this.options.handleItalicsShortcut) {
          this.options.handleItalicsShortcut(editor);
        }
        return true; // returning true prevents the default behavior
      },

      // CMD + Shift + P (on Mac)
      'Mod-Shift-P': ({ editor }) => {
        if (this.options.handleAttributesShortcut) {
          this.options.handleAttributesShortcut(editor);
        }
        return true; // returning true prevents the default behavior
      },

      // CMD + Shift + E (on Mac)
      'Mod-Shift-E': ({ editor }) => {
        if (this.options.handleEmojiShortcut) {
          this.options.handleEmojiShortcut(editor);
        }

        return true; // returning true prevents the default behavior
      },

      // CMD + Shift + L (on Mac)
      'Mod-Shift-L': ({ editor }) => {
        if (this.options.handleAddLink) {
          this.options.handleAddLink(editor);
        }
        return true; // returning true prevents the default behavior
      },

      // CMD + Shift + K (on Mac)
      'Mod-Shift-K': ({ editor }) => {
        if (this.options.handleAddMedia) {
          this.options.handleAddMedia(editor);
        }
        return true; // returning true prevents the default behavior
      },
    };
  },
});

export default KeyboardShortcuts;
